import type { ReebeloStoreT } from '@lambda/reebelo';
import settings, { priceFormater } from '@/settings';

export const TRADE_IN_STORES: ReebeloStoreT[] = [
  'reebelo-dev',
  'reebelo-us',
  'reebelo-au',
  'reebelo-nz',
];

export const isTradeInAvailable = (
  store: ReebeloStoreT = settings.store,
): boolean => TRADE_IN_STORES.includes(store);

/**
 * The store's trade-in value range, e.g. "$30-$800", or null where the store
 * has none set.
 */
export const getTradeInRange = (): string | null => {
  const { trade_in_min: min, trade_in_max: max } = settings;

  return min != null && max != null
    ? `${priceFormater.short(min, false)}-${priceFormater.short(max, false)}`
    : null;
};
